<div id="iframe-portalV1">
  <div class="container-fluid">
    <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
      <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
        <ol class="breadcrumb ol-sf-1">
          <li class="breadcrumb-item">
            <a *roles="['ROLE_MCKAY']" routerLink="/mckay/{{getUserCurrent().company?.uniqid}}">Home</a>
            <a *roles="['ROLE_CLIENT']" routerLink="/client/{{getUserCurrent().company?.uniqid}}">Home</a>
          </li>
          <li class="breadcrumb-item">List companies</li>
        </ol>
      </nav>
    </nav>
  </div>
  <div class="layout-main">
    <div class="container-fluid">
      <div class="pb-2 mb-3 border-bottom">
        <h3>
          <b>List companies</b>
          <p-messages [value]="msgsAws"></p-messages>
        </h3>
      </div>
      <div *ngIf="!loading">
        <div *ngIf="error" class="alert alert-warning alert-dismissible fade show">
          An error occurred while processing your request
          <button (click)="error = false" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div *ngIf="successActivateCompany" class="alert alert-success alert-dismissible fade show">
          The company was activated successfully
          <button (click)="hideSuccessActivateCompany()" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div *ngIf="successDeactivateCompany" class="alert alert-success alert-dismissible fade show">
          The company was deactivated successfully
          <button (click)="hideSuccessDeactivateCompany()" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div *ngIf="successSync" class="alert alert-success alert-dismissible fade show">
          Sync with salesforce has been done successfully.
          <button (click)="successSync = false" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div *ngIf="successDownloadUsersCsv" class="alert alert-success alert-dismissible fade show">
          List user was downloaded successfully
          <button (click)="hideSuccessDownloadUsersCsv()" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="row">
          <div class="col-12">
            <p-panel [toggleable]="true">
              <ng-template pTemplate="header">
                <span class="filter-title p-panel-title"><i class="fa fa-search"></i>Filter</span>
              </ng-template>
              <div class="row">
                <div class="col-4">
                  <p-floatLabel>
                    <input [(ngModel)]="clientSearchCriteria.nameOrShortnameOrBillingAccount" (ngModelChange)="filter()"
                           class="form-control" name="name" pInputText type="text"/>
                    <label>Company or billing account</label>
                  </p-floatLabel>
                </div>
                <div class="col-4">
                  <p-floatLabel>
                    <p-dropdown [(ngModel)]="clientSearchCriteria.status" (ngModelChange)="filter()"
                                [options]="statusItem" name="status"></p-dropdown>
                    <label>Status</label>
                  </p-floatLabel>
                </div>
                <div class="col-3" style="margin-top: 25px;">
                  <div class="row">
                    <div class="col-12 margin-checkbox">
                      <p-checkbox [(ngModel)]="clientSearchCriteria.activeDadReport" (ngModelChange)="filter()"
                                  binary="true" label="Has active dad report" name="dadReport"></p-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <p-floatLabel>
                    <input [(ngModel)]="clientSearchCriteria.userNameOrEmail"
                           (ngModelChange)="filter()"
                           autocomplete="off" class="form-control"
                           data-lpignore="true"
                           type="text" pInputText>
                    <label>User name or email</label>
                  </p-floatLabel>
                </div>
                <div class="col-7">
                  <div class="row" style="padding-top: 25px">
                    <label class="control-label col-2">DAD Reporting</label>
                    <div class="col-8" style="display: inherit;padding-top: 5px;">
                      <div class="margin-checkbox">
                        <p-checkbox [(ngModel)]="clientSearchCriteria.dadIce" (ngModelChange)="filter()" binary="true"
                                    label="ICE"
                                    name="dadIce" value="true"></p-checkbox>
                      </div>
                      <div class="margin-checkbox">
                        <p-checkbox  [(ngModel)]="clientSearchCriteria.dadEurex" (ngModelChange)="filter()"  binary="true"
                                    label="Eurex"
                                    name="dadEurex" value="true"></p-checkbox>
                      </div>
                      <div class="margin-checkbox">
                        <p-checkbox [(ngModel)]="clientSearchCriteria.dadEuronext" (ngModelChange)="filter()"
                                    binary="true"
                                    label="Euronext"
                                    name="dadEuronext" value="true"></p-checkbox>
                      </div>
                      <div class="margin-checkbox">
                        <p-checkbox [(ngModel)]="clientSearchCriteria.dadLme" (ngModelChange)="filter()" binary="true"
                                    label="LME"
                                    name="dadLme" value="true"></p-checkbox>
                      </div>
                      <div class="margin-checkbox">
                        <p-checkbox [(ngModel)]="clientSearchCriteria.dadLse" (ngModelChange)="filter()" binary="true"
                                    label="LSE"
                                    name="dadLse" value="true"></p-checkbox>
                      </div>
                      <div class="margin-checkbox">
                        <p-checkbox [(ngModel)]="clientSearchCriteria.dadTurq" (ngModelChange)="filter()" binary="true"
                                    label="Turq"
                                    name="dadTurq" value="true"></p-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="row" style="padding-top: 25px">
                    <label class="control-label pl-3 pt-2">See graphs from:</label>
                    <div style="display: inherit;padding-top: 5px;">
                      <div class="margin-checkbox">
                        <p-checkbox  [(ngModel)]="clientSearchCriteria.canSeeGraphMckay" (ngModelChange)="filter()"
                                    binary="true"
                                    label="McKay Brothers" name="seeGraphs"></p-checkbox>
                      </div>
                      <div class="margin-checkbox">
                        <p-checkbox [(ngModel)]="clientSearchCriteria.canSeeGraphQuincy" (ngModelChange)="filter()"
                                    binary="true"
                                    label="Quincy Data" name="seeGraphs"></p-checkbox>
                      </div>
                      <div class="margin-checkbox">
                        <p-checkbox [(ngModel)]="clientSearchCriteria.canSeeGraphVendor" (ngModelChange)="filter()"
                                    binary="true"
                                    label="Vendor" name="seeGraphs"></p-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row pt-2">
                    <div class="ml-auto mt-auto buttons-margin-left">
                      <div class="d-flex mt-2">
                        <div class="mr-2">
                          <button (click)="resetTable()" class="btn btn-outline-primary button-size"
                                  id="reset_top_button"
                                  type="reset">
                            <i aria-hidden="true" class="fa fa-refresh pr-2"></i>
                            Reset
                          </button>
                        </div>
                        <div *ngIf="canAddOrEditClients()" class="mr-2">
                          <button [disabled]="loading" class="btn btn-outline-primary button-size" id="add_top_button"
                                  routerLink="/{{getUserCurrent().company?.uniqid}}/company/new" type="button">
                            <i aria-hidden="true" class="fa fa-plus-circle pr-2"></i>Add company
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </p-panel>
          </div>
        </div>
        <span *ngIf="syncError && syncIsDisabled" class="sync-failed-message"> Syncing is disabled. Please contact <a
          href="mailto:admin@mckay-brothers.com">admin&#64;mckay-brothers.com</a></span>
        <span *ngIf="syncError && syncIsRunning" class="sync-failed-message"> Syncing is already running </span>
        <span *ngIf="syncError && automaticSync" class="sync-failed-message">Automatic syncing has stopped. Please contact <a
          href="mailto:admin@mckay-brothers.com">admin&#64;mckay-brothers.com</a> to fix </span>
        <p-table #dt (sortFunction)="customSort($event)" [columns]="cols" [customSort]="true"
                 [paginator]="true" [rowHover]="true"
                 [rows]="30" [tableStyle]="{'table-layout':'auto'}"
                 [totalRecords]=filteredListClients?.length [value]="filteredListClients" id="companies-list-table">

          <ng-template pTemplate="caption">
            <div class="p-helper-clearfix caption-buttons-container">
              <button (click)="exportListUserCSV()"
                      *roles="['ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_SUPER']"
                      class="alert-light" icon="fa fa-download pr-2" iconPos="left" id="_quick_download_button"
                      label="Export all users" pButton style="float:right; margin-left: 10px; background-color: #DD6A31" type="button"></button>
              <button (click)="downloadAllAuthorizations()"
                      *roles="['ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_SUPER']"
                      class="alert-light" icon="fa fa-file-archive-o pr-2" iconPos="left"
                      id="_download_all_authorizations_button" label="Download all authorizations" pButton
                      style="float:right; margin-left: 10px" type="button"></button>
              <button (click)="syncWithSalesforce()" *roles="['ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_SUPER']"
                      [disabled]="syncButtonDisabled" class="alert-light" icon="fa fa-refresh pr-2" iconPos="left"
                      id="_sync_salesforce_button" label="Sync with Salesforce" pButton
                      style="float:right; margin-left: 10px; background-color: #0088cc" type="button">
              </button>
            </div>
          </ng-template>
          <ng-template let-columns pTemplate="header">
            <tr>
              <th *ngFor="let col of cols" [className]="col.width"
                  [pSortableColumnDisabled]="!col.sortable" [pSortableColumn]="col.field">
                <span style="white-space: nowrap;">{{ col.header }}<p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon></span>
              </th>
            </tr>
          </ng-template>
          <ng-template let-client pTemplate="body">
            <tr>
              <td class="name-width">
                <button (click)="navigateToClient(client)" class="btn btn-link no-padding-button" name="name_link"
                        type="button">
                  {{ client.name }} ({{ client.sugarShortname }})  <i *ngIf="client.usersWithDifferentDomain" class="fa fa-exclamation-circle"
                                       style="color: red; font-size: x-large"
                                       title="Caution: at least one of the users has an unexpected email's domain name. Please check."></i>
                </button>
              </td>
              <td class="smaller-font name-width">
                <ul style="list-style-type: none; padding: 0; margin: 0; ">
                  <li *ngFor="let billingAccount of getVisibleBillingAccounts(client)" class ="resized">
                     {{ billingAccount }}
                  </li>
                  <li *ngIf="hasMoreBillingAccounts(client)">
                    <a (click)="toggleBillingAccountsExpansion(client, $event)" class="show-more-link" href="javascript:void(0)">
                      {{ isBillingAccountsExpanded(client) ? '[less]' : '[more]' }}
                    </a>
                  </li>
                </ul>

              </td>
              <td class="status-width">
                {{ client.sugarMckayStatus }}
              </td>
              <td class="status-width">
                {{ client.sugarQuincyStatus }}
              </td>
              <td>
                {{ client.ndaExecutionDate | date : "MMM dd, y" }}
                <ng-container *ngIf="client.ndaExpirationDate">
                  -> {{ client.ndaExpirationDate | date : 'MMM dd, y' }}
                </ng-container>
              </td>
              <td>
                {{ client.createdAt | date : "MMM dd, y" }}
              </td>
              <td>
                {{ client.lastLogin | date : "MMM dd, y" }}
              </td>
              <td class="action-width">
                <div class="d-flex flex-column">
                  <ng-container *ngIf="client.isActive">
                    <button *ngIf="canListUsers()" class="btn btn-link no-padding-button"
                            name="users_link"
                            routerLink="/{{getUserCurrent().company?.uniqid}}/{{client?.uniqid}}/users"
                            type="button">
                      <i aria-hidden="true" class="fa fa-user icon-color"></i>
                      <span> Users</span>
                    </button>
                    <button *ngIf="canAddOrEditClients() && !isAdminCompany(client)"
                            class="btn btn-link no-padding-button"
                            name="edit_link"
                            routerLink="/{{getUserCurrent().company?.uniqid}}/company/{{client?.uniqid}}/edit"
                            type="button">
                      <i aria-hidden="true" class="fa fa-pencil icon-color"></i>
                      <span> Edit</span>
                    </button>
                  </ng-container>
                  <ng-container *ngIf="client.awsCanBeEnabled">
                    <button (click)="activateOrDeactivateAwsAccess(client)"
                            *ngIf="canActivateAWS()"
                            class="btn btn-link no-padding-button" name="aws_access_link"
                            type="button">
                      <i [ngClass]="client.awsPacketCounterAccess ? 'fa-times-circle' : 'fa-check-circle'"
                         aria-hidden="true"
                         class="fa icon-color"></i>
                      <span *ngIf="client.awsPacketCounterAccess"> Deactivate AWS</span>
                      <span *ngIf="!client.awsPacketCounterAccess"> Activate AWS</span>
                    </button>
                  </ng-container>
                  <button (click)="activateOrDeactivate(client)" *ngIf="canAddOrEditClients()"
                          class="btn btn-link no-padding-button"
                          name="activate_deactivate_link"
                          type="button">
                    <i [ngClass]="client.isActive ? 'fa-times-circle' : 'fa-check-circle'" aria-hidden="true"
                       class="fa icon-color"></i>
                    <span *ngIf="client.isActive"> Deactivate</span>
                    <span *ngIf="!client.isActive"> Activate</span>
                  </button>
                </div>
              </td>
              <td class="action-width">
                <div class="d-flex flex-column">
                  <div *ngIf="client.isActive">
                    <button *ngIf="client?.hasLoa && canListLOAs()" class="btn btn-link no-padding-button"
                            name="LOAs" routerLink="/loa/{{client?.sugarUuid}}"
                            type="button">
                      <i aria-hidden="true" class="fa fa-list-alt icon-color"></i>
                      <span> LOAs</span>
                    </button>
                    <button *ngIf="client?.dadInLastMonth && canListDadAdmin()" class="btn btn-link no-padding-button"
                            name="dad_admin_link" routerLink="/dad-admin/{{client.uniqid}}"
                            type="button">
                      <i aria-hidden="true" class="fa fa-file icon-color"></i>
                      <span> DAD Admin</span>
                    </button>
                  </div>
                  <div *ngIf="client.isActive">
                    <button *ngIf="canManageInvoiceRecipients()"
                            class="btn btn-link no-padding-button"
                            name="manage_invoice_link"
                            routerLink="/{{client.uniqid}}/manage-inv-recipient"
                            type="button">
                      <i aria-hidden="true" class="fa fa-list-alt icon-color"></i>
                      <span> Invoice recipients</span>
                    </button>
                  </div>
                </div>
              </td>
              <td class="action-width">
                <div class="d-flex flex-column">
                  <div *ngIf="client.isActive">
                    <button *ngIf="hasPermissionClientProfile() && !isAdminCompany(client) && client?.hasQed"
                            class="btn btn-link no-padding-button"
                            name="qed_profile_link" routerLink="/{{client.uniqid}}/quincyClientProfile/qed"
                            type="button">
                      <i aria-hidden="true" class="fa fa-list-alt icon-color"></i>
                      <span> QED profile</span>
                    </button>
                    <button *ngIf="hasPermissionClientProfile() && !isAdminCompany(client) && client?.hasQrd"
                            class="btn btn-link no-padding-button"
                            name="qrd_profile_link" routerLink="/{{client.uniqid}}/quincyClientProfile/qrd"
                            type="button">
                      <i aria-hidden="true" class="fa fa-list-alt icon-color"></i>
                      <span> QRD profile</span>
                    </button>
                    <button *ngIf="hasPermissionClientProfile() && !isAdminCompany(client) && client?.hasQfd"
                            class="btn btn-link no-padding-button"
                            name="qfd_profile_link" routerLink="/{{client.uniqid}}/quincyClientProfile/qfd"
                            type="button">
                      <i aria-hidden="true" class="fa fa-list-alt icon-color"></i>
                      <span> QFD profile</span>
                    </button>
                    <button *ngIf="hasPermissionClientProfile() && !isAdminCompany(client) && client?.hasQhf"
                            class="btn btn-link no-padding-button"
                            name="qed_profile_link" routerLink="/{{client.uniqid}}/quincyClientProfile/qhf"
                            type="button">
                      <i aria-hidden="true" class="fa fa-list-alt icon-color"></i>
                      <span> QHF profile</span>
                    </button>
                    <div class="d-flex flex-column">
                      <div *ngIf="client.isActive">
                        <button
                          *ngIf="hasPermissionClientProfile() && !isAdminCompany(client) && client?.hasTsaaS"
                          class="btn btn-link no-padding-button"
                          name="tsaas_profile_link"
                          routerLink="/{{client.uniqid}}/clientProfile/timeSyncProfile"
                          type="button">
                          <i aria-hidden="true" class="fa fa-list-alt icon-color"></i>
                          <span> PTE Profile</span>
                        </button>

                      </div>
                    </div>
                    <button *ngIf="canListSchedules() && client?.hasSchedule"
                            class="btn btn-link no-padding-button"
                            name="list_schedules" routerLink="/schedules/{{client?.sugarUuid}}"
                            type="button">
                      <i aria-hidden="true" class="fa fa-list-alt icon-color"></i>
                      <span> BW profile</span>
                    </button>
                    <button *ngIf="hasPermissionClientProfile() && !isAdminCompany(client) && client?.hasNews"
                            class="btn btn-link no-padding-button"
                            name="news_profile_link" routerLink="/{{client.uniqid}}/quincyClientProfile/news"
                            type="button">
                      <i aria-hidden="true" class="fa fa-list-alt icon-color"></i>
                      <span> News profile</span>
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            {{ filteredListClients?.length }} results
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
